import React from "react";

export const SectionTitle = ({ titleTop, titleBottom }) => {
  return (
    <h3 className="font-light font-inter text-xl text-slate-600 tracking-tight uppercase leading-6 py-5">
      { titleTop} <br/>
      <span className="font-bold text-sm text-accent leading-3 tracking-normal"> { titleBottom } </span>
    </h3>
  )
}